import { getStoredAuthToken, removeAuthToken } from "./authTokenStorage";

function getStoredToken() {
  return getStoredAuthToken();
}

export function authHeaders(headers = {}) {
  const token = getStoredToken();

  if (!token) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
}

export async function handleResponse(response) {
  if (response.ok) {
    if (response.status === 204) return null;
    if (typeof response.text === "function") {
      const body = await response.text();
      if (!body) return null;
      return JSON.parse(body);
    }
    return response.json();
  }
  if (response.status === 401) {
    removeAuthToken();
    throw new Error("Unauthorized");
  }
  if (response.status === 400) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }
  if (response.status === 403) {
    const error = await response.text();
    let message = error || "Forbidden";
    try {
      const parsed = JSON.parse(error);
      message = parsed.error || parsed.message || message;
    } catch (parseError) {
      if (!parseError) message = error;
      // Keep plain text permission responses as-is.
    }
    const forbiddenError = new Error(message === "Forbidden" ? "Brak uprawnien" : message);
    forbiddenError.code = 403;
    throw forbiddenError;
  }
  const error = await response.text();
  throw new Error(`Network response was not ok. status:${response.status} error:${error}`);
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error(`API call failed. ${error}`);
  throw error;
}
